// Gelijke hoogtes per regel producten.
// Onderdelen: data-equal-height="<groep>", bijv. data-equal-height="vpe"
// Per element wordt het product bepaald via de omliggende .c-productcard.
// Producten die op dezelfde px-hoogte starten vormen een regel; per groep krijgen
// de onderdelen in die regel de hoogte van de hoogste.
class EqualHeight {
  constructor(options = {}) {
    this.config = {
      selector: '[data-equal-height]',
      cardSelector: '.c-productcard',
      debounce: null,
      debounceTimeOut: 150,
      ...options
    };
  }

  init() {
    this.update();

    window.addEventListener('load', () => this.update());
    window.addEventListener('resize', () => this.debouncedUpdate());

    // content die later binnenkomt (voorraad, prijzen, via AJAX geladen producten)
    document.addEventListener('equalheight:update', () => this.debouncedUpdate());
    const observer = new MutationObserver(() => this.debouncedUpdate());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // grid/lijst-weergave wisselt het aantal producten per regel
    document.addEventListener('change', e => {
      if (e.target.name === 'productlayout') {
        this.update();
      }
    });
  }

  debouncedUpdate() {
    clearTimeout(this.config.debounce);
    this.config.debounce = window.setTimeout(() => this.update(), this.config.debounceTimeOut);
  }

  update() {
    const elements = [...document.querySelectorAll(this.config.selector)];

    if (!elements.length) {
      return;
    }

    // groepen in DOM-volgorde, zodat bovenliggende onderdelen eerst gelijk worden
    const groups = [...new Set(elements.map(el => el.dataset.equalHeight))];

    elements.forEach(el => {
      el.style.minHeight = '';
    });
    groups.forEach(group => {
      // per px-hoogte van de productkaart een regel
      const rows = new Map();

      elements
        // verborgen elementen (display: none) niet meenemen
        .filter(el => el.dataset.equalHeight === group && el.getClientRects().length)
        .forEach(el => {
          const card = el.closest(this.config.cardSelector);

          if (!card) {
            return;
          }

          const top = Math.round(card.getBoundingClientRect().top);

          if (!rows.has(top)) {
            rows.set(top, []);
          }
          rows.get(top).push(el);
        });

      rows.forEach(rowElements => {
        if (rowElements.length < 2) {
          return;
        }

        const maxHeight = Math.max(...rowElements.map(el => el.getBoundingClientRect().height));

        rowElements.forEach(el => {
          el.style.minHeight = `${maxHeight}px`;
        });
      });
    });
  }
}

export default EqualHeight;
